import React from 'react';
import PropTypes from 'prop-types';
import { IoClose } from 'react-icons/io5';
import TourCard from '../components/TourCard';
import RegisterLoginForm from './RegisterLoginForm';

function Register({ onClose, handleFetchData }) {
  return (
    <div className="mx-auto flex w-full max-w-[920px] overflow-hidden rounded-2xl bg-zinc-900 shadow-2xl shadow-black/60">
      <TourCard className="hidden md:block w-[42%] shrink-0 min-h-[480px]" />
      <section className="flex flex-1 flex-col min-w-0 px-6 py-7 sm:px-8 sm:py-9 md:px-10">
        <header className="flex items-start justify-between gap-4 mb-2">
          <div>
            <h2 className="text-xl font-semibold text-white sm:text-2xl">Login / Sign up</h2>
            <p className="mt-1.5 text-sm text-white/50">
              Enter your mobile number to continue booking
            </p>
          </div>
          <button
            type="button"
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/10 text-white/80 hover:bg-white/15 hover:text-white transition-colors"
            aria-label="Close login"
            onClick={(e) => {
              e.stopPropagation();
              onClose?.();
            }}
          >
            <IoClose className="w-5 h-5" />
          </button>
        </header>
        <RegisterLoginForm onClose={onClose} handleFetchData={handleFetchData} />
      </section>
    </div>
  );
}

Register.propTypes = {
  onClose: PropTypes.func,
  handleFetchData: PropTypes.func,
};

export default Register;
